import Vue from 'vue'

/**
 * Attempts to create a human readable string from SNS event names, returns the passed value otherwise.
 * @param {string} str - event string
 * @returns {string} corresponding module name(s) based on the prefix or the passed string if there's no match
 */
const parseEventString = str => {
  const prefixModuleMap = {
    'bc.': 'All modules',
    'bc.lines': 'Lines',
    'bc.quote': 'Quote',
    'bc.policies': 'Policies'
  }
  let event
  try {
    event = JSON.parse(`[${str}]`)
      .map(event => event.prefix ? (prefixModuleMap[event.prefix] || event.prefix) : JSON.stringify(event))
      .join(', ')
  } catch (err) {
    event = str
  }
  return event
}

export const mutations = {
  integrations (state, integrations) {
    state.integrations = integrations
  },

  setEventsLoading (state, value) {
    state.events.loading = value
  },
  setSubscriptions (state, subscriptions) {
    state.events.subscriptions = subscriptions.map(subscription => {
      subscription.subscribedEvents = parseEventString(subscription.attributes.events)
      return subscription
    })
    // clear existing messages and create message slots for every subscription
    state.events.subscriptionMessages = {}
    subscriptions.forEach(({ id }) => {
      Vue.set(state.events.subscriptionMessages, id, { loading: false, data: [] })
    })
  },
  removeSubscription (state, subscriptionID) {
    state.events.subscriptions.splice(state.events.subscriptions.findIndex(s => s.id === subscriptionID), 1)
  },
  setSubscriptionMessages (state, { subscriptionID, value }) {
    Vue.set(state.events.subscriptionMessages, subscriptionID, {
      ...(state.events.subscriptionMessages[subscriptionID] || {}),
      ...value
    })
  }
}
